var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-sign"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,6.228c-3.187,0-5.771,2.584-5.771,5.772S8.813,17.771,12,17.771s5.771-2.584,5.771-5.771S15.187,6.228,12,6.228z  M12.937,13.136c-0.216,0-1.004,0-1.729,0c-0.216,0-0.265-0.17-0.259-0.249c0.101-1.226,0.918-1.345,1.17-1.438 c0.253-0.092,0.332-0.213,0.332-0.525c0-0.236-0.167-0.389-0.432-0.389c-0.43,0-0.579,0.106-0.662,0.368 c-0.049,0.153-0.344,0.104-0.344,0.104s-0.698,0-1.318,0c-0.166,0-0.199-0.121-0.199-0.249c0-1.755,1.503-2.169,2.381-2.169 s2.425,0.338,2.425,1.969C14.303,12.471,13.153,13.136,12.937,13.136z M13,15.75c0,0.137-0.113,0.25-0.25,0.25h-1.5 C11.113,16,11,15.887,11,15.75v-1.5c0-0.137,0.113-0.25,0.25-0.25h1.5c0.137,0,0.25,0.113,0.25,0.25V15.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.751c24c1.svg";
export { ForwardRef as ReactComponent };